import React from 'react';
import { format } from 'date-fns';

import { shortDateTimeFormat } from '@crm-package/app';

import { getBalanceForDormantClientNotification } from '../../adapters';
import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { LeadInfo } from './utils';

export const DormantClientDetails: React.FC<INotificationGridItem> = ({
  date,
  notificationDetails: { data },
}) => (
  <>
    <DetailsRow label="Date" value={date} />
    <DetailsRow
      label="Client ID"
      component={<LeadInfo leadId={data.leadId} />}
    />
    {data.dormantFeeCommission !== undefined && (
      <DetailsRow
        label="Dormant Fee Commission"
        value={String(data.dormantFeeCommission)}
      />
    )}
    <DetailsRow
      label="Balance"
      value={getBalanceForDormantClientNotification(data.balance)}
    />
    <DetailsRow
      label="Last trading Date"
      value={
        data.lastTradeDate
          ? format(new Date(data.lastTradeDate), shortDateTimeFormat)
          : ''
      }
    />
  </>
);
